// extracted by mini-css-extract-plugin
export var equalColumn = "_iy-0";